(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('floever-quote')) {
    customElements.define('floever-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) { this.setAttribute('data-revealed', ''); return; }
        const paragraph = this.querySelector('.text-block p');
        if (!paragraph || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.dataset.initialized = 'true';
        const accessible = document.createElement('span');
        accessible.className = 'visually-hidden';
        accessible.textContent = paragraph.textContent;
        const visual = document.createElement('span');
        visual.setAttribute('aria-hidden', 'true');
        while (paragraph.firstChild) visual.append(paragraph.firstChild);
        let index = 0;
        const walk = document.createTreeWalker(visual, NodeFilter.SHOW_TEXT);
        const nodes = [];
        while (walk.nextNode()) nodes.push(walk.currentNode);
        for (const node of nodes) {
          const fragment = document.createDocumentFragment();
          for (const word of node.textContent.split(/(\s+)/)) {
            if (/^\s+$/.test(word)) { fragment.append(document.createTextNode(word)); continue; }
            const group = document.createElement('span'); group.className = 'quote-word';
            group.textContent = word;
            group.style.setProperty('--quote-delay', (index++ * 180) + 'ms');
            fragment.append(group);
          }
          node.replaceWith(fragment);
        }
        paragraph.append(accessible, visual);
        this.setAttribute('data-animated', '');
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.setAttribute('data-revealed', ''); this.observer.disconnect(); }
        }, { threshold: .25 });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
